exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button{border-radius:2px}.navbar{-webkit-box-shadow:0 1px 2px rgba(10,10,10,.1);box-shadow:0 1px 2px rgba(10,10,10,.1)}.navbar-item img{max-height:4rem}.navbar-dropdown{border-bottom-left-radius:2px;border-bottom-right-radius:2px}.navbar-divider{height:1px}.navbar-brand>.navbar-item.is-active{background-color:transparent!important}.navbar-brand>.navbar-item.is-active:hover{background:#e8e8e8!important}", ""]);

// exports
